import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

import { Container } from "../../styles/GlobalStyles";
import {
  Form,
  Button,
  Content,
  CardHeader,
  RegisterButton,
  ForgetPasswordContainer,
  ForgetPassword,
} from "./styled";

import api from "../../api/axios";

import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../store/modules/auth/actions";
import ReCAPTCHA from "react-google-recaptcha";
import WhatsappButton from "../../components/WhatsappButton";

export default function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const recaptchaRef = useRef();

  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);

  const [userData, setUserData] = useState({
    email: "",
    password: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [captcha, setCaptcha] = useState(null);

  const handleCaptcha = (value) => {
    setCaptcha(value);
  };

  const [error, setError] = useState("");

  async function handleSubmit(e) {
    e.preventDefault();
    setIsLoading(true);
    setError("");

    const { email, password } = userData;

    if (!email || !password) {
      setError("Por favor, preencha todos os campos!");
      setIsLoading(false);
      return;
    }

    if (!captcha) {
      setError("Por favor, preencha o captcha!");
      setIsLoading(false);
      return;
    }

    try {
      await api.post("/user/login", { email, password, captcha });

      dispatch(
        actions.loginRequest({
          email,
          password,
        })
      );
    } catch (error) {
      setIsLoading(false);
      setError(error.response?.data?.error || "Erro desconhecido");

      if (recaptchaRef.current) {
        recaptchaRef.current.reset();
        setCaptcha(null);
      }
    }
  }

  const handleRegisterClick = (e) => {
    e.preventDefault();
    navigate("/cadastro");
  };

  const handlePasswordForgetClick = () => {
    navigate("/esqueci-senha");
  };

  // Prevents code breaking by manually changing the redux state
  useEffect(() => {
    async function checkTokenAndRedirect() {
      try {
        await api.get("/user/me");
        navigate("/perfil");
      } catch (err) {
        dispatch(actions.loginFailure());
      }
    }

    if (isLoggedIn) {
      checkTokenAndRedirect();
    }
  }, [isLoggedIn, navigate, dispatch]);

  return (
    <Content>
      <WhatsappButton />
      <Container>
        <CardHeader>
          <a href="https://ticoopbrasil.coop.br/oportunidades-ti/">
            <img
              src="https://ticoopbrasil.coop.br/wp-content/uploads/2020/12/logo-ticoop-cor.png.webp"
              alt="Logo Ticoop"
            />
          </a>
        </CardHeader>
        <Form onSubmit={handleSubmit}>
          {/* Username */}
          <label for="email">E-mail:</label>
          <input
            id="email"
            name="email"
            type="text"
            value={userData.email}
            onChange={(e) => {
              setUserData({
                ...userData,
                email: e.target.value.toLocaleLowerCase().trim(),
              });
              setError("");
            }}
          />
          {/* Password */}
          <label for="password">Senha:</label>
          <input
            id="password"
            name="password"
            type="password"
            value={userData.password}
            onChange={(e) => {
              setUserData({ ...userData, password: e.target.value });
              setError("");
            }}
          />
          <ForgetPasswordContainer>
            <ForgetPassword onClick={handlePasswordForgetClick}>
              Esqueci minha senha
            </ForgetPassword>
          </ForgetPasswordContainer>
          <ReCAPTCHA
            sitekey="6LdfQmQrAAAAAIPfiDlA7XO9JK85WeAzyO7vRSov"
            onChange={handleCaptcha}
            ref={recaptchaRef}
          />
          <div className="erro">{error ? error : ""}</div>
          <Button disabled={isLoading} type="submit">
            Entrar
          </Button>
          <RegisterButton onClick={handleRegisterClick}>
            Cadastre-se
          </RegisterButton>
        </Form>
      </Container>
    </Content>
  );
}
